'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import PlanetPaymentKit from 'Components/Front/PlanetiPageKit';
import PaymentFailure from 'Components/Front/PaymentFailure';
export default class RedirectFailurePage extends Component {
  state = {
    loading: false,
    status_messages: {},
    retrying: false,
    booking_id: window.localStorage.getItem('current_booking_id')
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      "header-bemit": ['inline']
    }), /*#__PURE__*/React.createElement("div", {
      className: "page-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-content u-margin-top-30"
    }, state.retrying ? /*#__PURE__*/React.createElement(PlanetPaymentKit, {
      id: state.booking_id
    }) : /*#__PURE__*/React.createElement(PaymentFailure, null, getFormStatus({
      error: 'Échec du paiement.'
    })))));
    return output;
  }
}

// http://localhost:1101/paiement/planet/echec?MerchantRef=6343e89d8a02380ee0650b9a&TxID=A25A1C8E-E2BE-4FEA-BFE5-48DCA584D0C2&TokenNo=
